import ActivityModal from '../components/controls/ActivityModal'
import { modals } from '../components/services/ModalService'

class ActivityManagerClass {
    openActivity = (tableId: string) => {
        modals.openConfirm({
            title: 'Activity',
            children: <ActivityModal tableId={tableId} />
        })
    }
}

const ActivityManager = new ActivityManagerClass()
export default ActivityManager
